<div id="chartdiv" style="width:93vw; height:80vh; position: absolute; top:50; left:3.5%; overflow: hidden;"></div>
<div #planmodal data-toggle="modal" data-target="#pplist" ></div>
  <!-- Modal -->
  <div  class="modal fade" id="pplist" tabindex="-1" role="dialog" >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Planning Information</h5>
          <button #closeplanmodal type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span >&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container pl-0 pr-0">
            <p class="mb-0"><b>Projects for {{inspectPersonProjects}} on the {{timeClicked | date: 'yyy-MM-dd'}}</b></p>
            <div *ngFor="let p of modallist" class="row " (click)="clickOnProject(p)">
              <div class="col-12">
                <div class="card mt-2 cursor-pointer">
                  <div class="card-header cursor-pointer">
                    <p class="card-title mb-0 cursor-pointer">{{p.title}} {{p.start_date | date: 'yyy-MM-dd'}} - {{p.end_date | date: 'yyy-MM-dd'}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>